import last from "lodash/last";
import uniq from "lodash/uniq";
import { getOriginalResource } from "PFApp/booking/parts/helpers";
import { CalendarView } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { CategoryRowItem, ProfileBasic, Row, RowType } from "PFApp/booking/types/row";
import { isProjects } from "PFApp/booking/utils/calendar_root.utils";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { WorkforceItem } from "PFCore/hooks/queries/bookings/workforce/use_workforce_entries";
import { Profile } from "PFCore/hooks/queries/profile";

export const isRowContainingBookings = (
  { type }: Row,
  calendarRoot: CalendarRoot,
  view: CalendarView | null
) => {
  if (isProjects(calendarRoot)) {
    return type === RowType.Profile;
  } else {
    return (
      type !== RowType.Profile ||
      (!!view && [CalendarView.BookingsOnly, CalendarView.Compressed].includes(view))
    );
  }
};

export const mapToProfileWithActivityId = (
  row: Row,
  rowsByKey: Record<string, Row>,
  calendarRoot: CalendarRoot,
  allBookingsModeRowsState: Record<string, "all" | "partial" | "off" | "unset" | undefined> | null
): Profile => {
  const { key, type, parents } = row;
  const closestParentKey = last(parents);
  const parentRow = closestParentKey ? rowsByKey[closestParentKey] : null;
  const originalResource = getOriginalResource(row, calendarRoot);
  const originalResourceId = originalResource?.id;
  if (isProjects(calendarRoot)) {
    const isAllBookingsModeEnabledForRow =
      !!allBookingsModeRowsState?.[key] && ["all", "partial"].includes(allBookingsModeRowsState[key]);
    const parentRowActivityId = (parentRow?.original as ProjectItem).activity.id;
    const activityId = uniq([parentRowActivityId, ...((originalResource as ProfileBasic).activityIds ?? [])]);
    return {
      id: originalResourceId!,
      rowKey: key,
      ...(isAllBookingsModeEnabledForRow ? {} : { activityId })
    };
  } else {
    if (type === RowType.Profile) {
      return { id: originalResourceId!, rowKey: key };
    } else {
      const activityId = originalResourceId ?? false;
      return {
        id: (parentRow?.original as WorkforceItem).profile.id,
        rowKey: key,
        activityId,
        bookingCategoryIds:
          activityId === false ? (row.original as CategoryRowItem).bookingCategoryIds : undefined
      };
    }
  }
};
